import React, { useEffect, useRef, useState } from "react";
import { ThemeProvider, useTheme } from "styled-components";
import { lighten } from "polished";
import Score from "../../../../Score/score-display";
import scrollToBar from "../../Common/scrollToBar";
import { IProps } from "./interfaces";

import { Container, Background } from "./styles";

const ScoreVideoSlide = ({ scores, currentPoint, width, opacity, notFollowNotes = false }: IProps) => {
    const [currentScore, setCurrentScore] = useState<number | null>(null);
    const [playingNote, setPlayingNote] = useState<number | null>(null);
    const [distribution, setDistribution] = useState<number[][]>([]);
    const scoreRef = useRef<HTMLDivElement>();
    const theme = useTheme();
    const events: ({
        type: "showScore" | "note" | "hideScore" | "endOfScore",
        scoreIndex: number | null,
        barIndex?: number,
        noteIndex?: number,
        playingNote?: number | null,
    } | null)[] = [null];
    scores.forEach(({ score }, scoreIndex) => {
        let playingNote = 0;
        events.push({
            type: "showScore",
            scoreIndex,
        });

        score.bars.forEach((bar, barIndex) => {
            if (!bar) return;
            bar.notes.forEach((note, noteIndex) => {
                events.push({
                    type: "note",
                    scoreIndex,
                    barIndex,
                    noteIndex,
                    playingNote,
                })
                playingNote++;
            })
        })
        events.push({
            type: "endOfScore",
            scoreIndex,
            playingNote: null,
        })

        events.push({
            type: "hideScore",
            scoreIndex: null,
        });
    });

    useEffect(() => {
        const event = events[currentPoint];
        if (event === null || event === undefined) {
            setCurrentScore(null);
            return;
        }
        if (event.scoreIndex !== currentScore) {
            setCurrentScore(event.scoreIndex);
        }
        if (event.playingNote !== undefined) {
            if (!notFollowNotes) {
                setPlayingNote(event.playingNote);
            }
            if (event.noteIndex === 0) {
                scrollToBar(distribution, scoreRef.current!, event.barIndex!);
            }
        }
    }, [currentPoint]);
    const setScoreRef = (element: HTMLDivElement) => {
        scoreRef.current = element
        if (element) {
            element.scrollTop = 20;
        }
    }
    return (
        <Container
            style={{
                height: (currentScore !== null && distribution?.length > 0)
                    ? (scoreRef.current!.scrollHeight / distribution.length)
                    : 0
            }}
        >
            <Background
                style={{
                    backgroundImage: `linear-gradient(to bottom, rgba(255, 255, 255, ${opacity}) 0%, rgba(255, 255, 255, ${opacity}) 97%, rgba(255, 255, 255, 0) 100%)`
                }}
            />
            {currentScore !== null && (
                <ThemeProvider theme={{
                    ...theme,
                    c: {
                        ...theme.c,
                        grey7: "#333333",
                        playLight: lighten(0.2, theme.c.play)
                    }
                }}>
                    <Score
                        score={scores[currentScore!].score}
                        scale={scores[currentScore!].scale * (width / 1280)}
                        playing
                        playingNote={playingNote !== null ? [playingNote] : undefined}
                        setRef={setScoreRef}
                        setDistribution={setDistribution}
                    />
                </ThemeProvider>
            )}
        </Container>
    );
};

export default ScoreVideoSlide;
